import { ChangeDetectionStrategy, Component, computed, inject } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { StrategyEx } from "@front/m19-models";
import {
  AccountSelectionService,
  AuthService,
  OrganizationAccountGroupService,
  SegmentService,
} from "@front/m19-services";
import { MODAL_DATA, ModalRef } from "@front/m19-ui";
import { StrategyAdvancedSettingsComponent } from "@m19-board/shared/strategy-advanced-settings/strategy-advanced-settings.component";
import { AdvancedSettings } from "@m19-board/strategies/strategy-page/strategy-page-advanced-settings/strategy-page-advanced-settings.component";
import { StrategyPageService } from "@m19-board/strategies/strategy-page/strategy-page.service";

export interface AdvancedSettingsModalData {
  strategy: StrategyEx;
}

@Component({
  selector: "app-advanced-settings-modal",
  imports: [StrategyAdvancedSettingsComponent],
  templateUrl: "./advanced-settings-modal.component.html",
  providers: [StrategyPageService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdvancedSettingsModalComponent {
  readonly segmentService = inject(SegmentService);
  readonly organizationAccountGroupService = inject(OrganizationAccountGroupService);
  readonly accountSelectionService = inject(AccountSelectionService);
  readonly authService = inject(AuthService);

  modalData = inject<AdvancedSettingsModalData>(MODAL_DATA);
  modalRef = inject(ModalRef);

  accountMarketplace = toSignal(this.accountSelectionService.singleAccountMarketplaceSelection$, { requireSync: true });
  allOrganizationAccountGroups = toSignal(this.organizationAccountGroupService.allOrganizationAccountGroups$);
  user = toSignal(this.authService.loggedUser$);

  advancedSettings = computed<Record<AdvancedSettings, boolean>>(() =>
    StrategyPageService.getAdvancedSettings(
      this.modalData.strategy,
      this.accountMarketplace(),
      this.allOrganizationAccountGroups()!,
      undefined,
      this.user(),
    ),
  );
}
